import React from 'react';
import { Grid, Form, Segment, Button, Header, Message, Icon} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import '../App.css';
import firebase from '../../firebase';

class Login extends React.Component {
    
    // state to store user form data.
    state = {
        email: '',
        password: '',
        errors: [],
        loading: false,
    }

    // to capture value of user data.
    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }

    // helper to display errors
    displayErrors = (errors) => errors.map((error,index) => <p key={index}>{error.message}</p>)
    
    // helper function to highlight error field.
    handleInputError = (errors,inputName) => {
        return errors.some(error => error.message.toLowerCase().includes(inputName)) ? 'error' : '' ;
    }

    // function to handle form submit.
    handleSubmit = (event) => {
        event.preventDefault();
        if(this.isFormValid(this.state)){
            this.setState({loading: true, errors:[]});
            firebase
            .auth()
            .signInWithEmailAndPassword(this.state.email, this.state.password)
            .then(signedInUser => {
                console.log(signedInUser);
            })
            .catch(err => {
                console.log(err);
                this.setState({errors: this.state.errors.concat(err), loading:false})
            })
        }
    }

    isFormValid = ({ email, password }) => {
        return email && password;
    }

    render() {
        const { email, password, errors, loading} = this.state;
        return (
            <Grid textAlign="center" verticalAlign="middle" className="app">
                <Grid.Column style={{ maxWidth: 450 }}>
                    
                    <Header as="h1" icon color="violet" textAlign="center">
                        <Icon name="code branch" color="violet" />
                        Login For DevChat
                    </Header>

                    <Form size="large" onSubmit={this.handleSubmit}>
                        <Segment stacked>

                            
                            <Form.Input fluid name="email" icon="mail" iconPosition="left" placeholder="Email Address" onChange={this.handleChange} type="email" value={email} className={this.handleInputError(errors,'email')} />

                            <Form.Input fluid name="password" icon="lock" iconPosition="left" placeholder="password" onChange={this.handleChange} type="password" value={password} className={this.handleInputError(errors,'password')}/>

                            <Button disabled={loading} className={loading ?'loading': ''} color="violet" fluid size="large">Submit</Button>
                        </Segment>
                    </Form>
                    {errors.length>0 && (
                        <Message error>
                            <h3>Error</h3>
                            {this.displayErrors(errors)}
                        </Message>
                    )}
                    <Message>Don't have an account?<Link to="/register">Register</Link></Message>
                </Grid.Column>
            </Grid>
        )
    }
}

export default Login;